/* eslint-disable @stylistic/max-len */

const filter = `
  <svg preserveAspectRatio="xMidYMid meet"  viewBox="0 0 12 10" >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1845.000000, -271.000000)" fill="currentColor" fillRule="nonzero">
        <g transform="translate(1845.000000, 271.000000)">
          <path d="M8,6.66666667 L4,6.66666667 C3.63333333,6.66666667 3.33333333,6.96666667 3.33333333,7.33333333 C3.33333333,7.7 3.63333333,8 4,8 L8,8 C8.36666667,8 8.66666667,7.7 8.66666667,7.33333333 C8.66666667,6.96666667 8.36666667,6.66666667 8,6.66666667 Z"/>
          <path d="M9.33333333,3.33333333 L2.66666667,3.33333333 C2.3,3.33333333 2,3.63333333 2,4 C2,4.36666667 2.3,4.66666667 2.66666667,4.66666667 L9.33333333,4.66666667 C9.7,4.66666667 10,4.36666667 10,4 C10,3.63333333 9.7,3.33333333 9.33333333,3.33333333 Z"/>
          <path d="M0.666666667,1.33333333 L11.3333333,1.33333333 C11.7,1.33333333 12,1.03333333 12,0.666666667 C12,0.3 11.7,0 11.3333333,0 L0.666666667,0 C0.3,0 0,0.3 0,0.666666667 C0,1.03333333 0.3,1.33333333 0.666666667,1.33333333 Z"/>
        </g>
      </g>
    </g>
  </svg>
`.trim()

const rowGroup = `
  <span class="ag-icon">
    <svg preserveAspectRatio="xMidYMid meet" width="12px" height="15px" viewBox="0 0 12 15">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-3417.000000, -764.000000)" fill="#808080">
          <g transform="translate(3417.000000, 764.000000)">
            <g transform="translate(1.846154, 3.529412)" fillRule="nonzero">
              <path
                d="M5.96461538,4.93235294 L5.96461538,3.95294118 L1.29230769,3.95294118 L1.29230769,0.42745098 L0.246154154,0.42745098 L0.246154154,7.85098059 C0.246154154,9.23710702 1.64304437,10.3607841 3.13846154,10.3607841 L5.96461538,10.3607841 L5.96461538,9.38039206 L3.13846154,9.38039206 C2.01689866,9.38039206 1.29230769,8.53763423 1.29230769,7.49803941 L1.29230769,4.93235294 L5.96461538,4.93235294 Z"
              />
            </g>
            <path
              d="M9.41538462,14.1176471 C9.92518592,14.1176471 10.3384615,13.7226042 10.3384615,13.2352941 C10.3384615,12.747984 9.92518592,12.3529412 9.41538462,12.3529412 C8.90558331,12.3529412 8.49230769,12.747984 8.49230769,13.2352941 C8.49230769,13.7226042 8.90558331,14.1176471 9.41538462,14.1176471 Z M9.41538462,15 C8.395782,15 7.56923077,14.2099143 7.56923077,13.2352941 C7.56923077,12.260674 8.395782,11.4705882 9.41538462,11.4705882 C10.4349872,11.4705882 11.2615385,12.260674 11.2615385,13.2352941 C11.2615385,14.2099143 10.4349872,15 9.41538462,15 Z"
              fillRule="nonzero"
            />
            <path
              d="M9.41538462,8.82352941 C9.92518592,8.82352941 10.3384615,8.42848654 10.3384615,7.94117647 C10.3384615,7.4538664 9.92518592,7.05882353 9.41538462,7.05882353 C8.90558331,7.05882353 8.49230769,7.4538664 8.49230769,7.94117647 C8.49230769,8.42848654 8.90558331,8.82352941 9.41538462,8.82352941 Z M9.41538462,9.70588235 C8.395782,9.70588235 7.56923077,8.91579662 7.56923077,7.94117647 C7.56923077,6.96655632 8.395782,6.17647059 9.41538462,6.17647059 C10.4349872,6.17647059 11.2615385,6.96655632 11.2615385,7.94117647 C11.2615385,8.91579662 10.4349872,9.70588235 9.41538462,9.70588235 Z"
              fillRule="nonzero"
            />
            <ellipse cx="2.58461538" cy="2.29411765" rx="1.84615385" ry="1.76470588" />
          </g>
        </g>
      </g>
    </svg>
  </span>
`.trim()

const cancel = `
  <svg preserveAspectRatio="xMidYMid meet" width="16px" height="16px" viewBox="0 0 12 12">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fillRule="nonzero" fill="#ffffff">
        <polygon points="9 8.154 8.154 9 6 6.846 3.846 9 3 8.154 5.154 6 3 3.846 3.846 3 6 5.154 8.154 3 9 3.846 6.846 6" />
      </g>
    </g>
  </svg>
`.trim()

export const agGridIcons = {
  filter,
  columnMoveGroup: rowGroup,
  rowGroupPanel: rowGroup,
  cancel
}
